import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { LanguageConsumer } from '../../state'

const Query = ({ render }) => (
  <LanguageConsumer>
    {({ lang }) => (
      <StaticQuery
        query={graphql`
          query {
            allContent: allFile(
              filter: { relativePath: { glob: "content/pages/education/*.md" } }
            ) {
              nodes {
                relativePath
                childMarkdownRemark {
                  frontmatter {
                    content {
                      title
                      content_navigation {
                        about
                        educators
                        courses
                      }
                      about_page {
                        main_video_id
                        body_text
                        education_partners_title
                        education_partners {
                          name
                          thumbnail
                          link
                        }
                      }
                      courses_page {
                        body_text
                      }
                    }
                  }
                }
              }
            }

            educators: file(relativePath: { eq: "content/educators.md" }) {
              childMarkdownRemark {
                frontmatter {
                  educator_profiles
                }
              }
            }
          }
        `}
        render={({ allContent, educators }) => {
          const content = allContent.nodes
            .filter(
              (node) =>
                node.relativePath ===
                `content/pages/education/education-${lang}.md`
            )
            .shift()
          if (!content || !content.childMarkdownRemark)
            throw new Error(
              `No education translations found for language ${lang}`
            )
          return render(
            content.childMarkdownRemark.frontmatter.content,
            educators.childMarkdownRemark.frontmatter.educator_profiles
          )
        }}
      />
    )}
  </LanguageConsumer>
)

Query.propTypes = {
  render: PropTypes.func.isRequired
}

export default Query
